var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doc-list"},[_c('div',{staticClass:"doc-list__title text_15 text_bold"},[_vm._v(_vm._s(_vm.$t("docs")))]),_vm._v(" "),_vm._l((_vm.docs),function(title,slug){return _c('nuxt-link',{key:slug,attrs:{"to":`/dokumenty/${slug}/`}},[_c('div',{staticClass:"text_13"},[_c('span',[_vm._v(_vm._s(title))])])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }